import { Box, styledComponent } from '@hermes/web-components'

export const GridTemplate = styledComponent(Box)(({ theme }) => ({
  display: 'grid',
  rowGap: '40px',
  columnGap: '32px',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(1, 1fr) !important',
    rowGap: '32px'
  }
}))

export const FactsContainer = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  [theme.breakpoints.down('md')]: {
    gap: '32px'
  }
}))

export const LastRowsTemplate = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column'
  }
}))
